import { PageShell } from '../../components/PageShell'

type LegalPageProps = { html: string }

// Standalone Chalk & Paper-themed legal page (privacy / terms). The copy is
// ported verbatim from the API's legal HTML (trusted static content) and
// injected via PageShell; styling comes from the `.legal` block in brand.css.
// Rendered outside Layout (like delete-account) with just a back link to home.
export const LegalPage = ({ html }: LegalPageProps) => <PageShell variant="legal" bodyHtml={html} />

export default LegalPage
